module.exports = __webpack_public_path__ + "static/media/PC-banner3.8e664c16.png";